<template>
  <check-base-layout
    :pagetitle="pagetitle"
    :check-info-data="checkFrom"
  >
    <template>
<!--      <check-module :ishow-title="false">-->
<!--        <el-link-->
<!--          type="danger"-->
<!--          :underline="false"-->
<!--        ><i class="el-icon-warning-outline"></i>当前产品中存在未发货产品，审批通过后将由财务部门进行开票处理。-->
<!--        </el-link>-->
<!--      </check-module>-->
<!--      <check-module :title="`合同总览`">-->
<!--        <compart-module :compart-data="checkFrom.orderContractBaseOtherPayVo" :isDeilvery="true"></compart-module>-->
<!--      </check-module>-->
      <div>
        <customer-module :customer-data="checkFrom.customerAccountCreditVo"></customer-module>
      </div>
      <check-module :title="`开票信息`">
        <template>
          <el-row>
            <el-col :span="8">
              <div class="pb20">开票编号：{{orderInvoiceContentStateVo.megerCode}}</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">开票类型：{{orderInvoiceContentStateVo.bilingType}}</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">发票类型：{{orderInvoiceContentStateVo.invoiceType}}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div class="pb20">公司名称：{{orderInvoiceContentStateVo.cusName}}</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">税号：{{orderInvoiceContentStateVo.taxNumber}}</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">银行账号：{{orderInvoiceContentStateVo.bankNumber}}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div class="">开票地址：{{orderInvoiceContentStateVo.invoiceAddress}}</div>
            </el-col>
            <el-col :span="8">
              <div class="">开户行：{{orderInvoiceContentStateVo.bankOpen}}</div>
            </el-col>
            <el-col :span="8">
              <div class="">开票电话：{{orderInvoiceContentStateVo.invoicePhone}}</div>
            </el-col>
          </el-row>
        </template>
      </check-module>
      <check-module :title="`收票信息`">
        <el-row>
          <el-col :span="8">
            <div class="">收票人：{{orderInvoiceContentStateVo.receivePeople}}</div>
          </el-col>
          <el-col :span="8">
            <div class="">收票地址：{{orderInvoiceContentStateVo.receiveAddress}}</div>
          </el-col>
          <el-col :span="8">
            <div class="">联系电话：{{orderInvoiceContentStateVo.receivePhone}}</div>
          </el-col>
        </el-row>
      </check-module>
      <check-module :title="`开票清单`" :is-table="true">
        <template>
          <info-table
            :field-arr="tableField"
            :table-data="orderContractInvoiceStateVoList"
            :table-height="`300px`"
          ></info-table>
          <el-card shadow="never" style="border-radius: 0;border-top: 0;color: #606266;">
            开票总额：{{orderInvoiceContentStateVo.amount | toFixed}}
          </el-card>
        </template>
      </check-module>
      <check-module :title="`开票产品合同清单`" :is-table="true">
        <template>
          <info-table
            :field-arr="tableFieldex"
            :to-fixed-format="['invoiceMoneyProcess','invoiceMoneyFilish','invoiceMoney','accountsReceived','accountsCollect','contractTotal']"
            :table-data="checkFrom.contractInvoicedProductsList"
            :table-height="`300px`"
          ></info-table>
        </template>
      </check-module>
    </template>
    <template v-slot:checkFooter>
      <slot name="footer">
        <check-module :title="`审批信息`">
          <check-info-module :check-data="checkFrom.systemFlowRunAuditOrgVos"></check-info-module>
        </check-module>
      </slot>
    </template>
  </check-base-layout>
</template>

<script>
import poMixins from '@/mixin/poMixins'
import checkApi from '@/api/workbench/check'
import { isSuccess } from '@/util/tool'
import { deepClone } from '@/util'
import { deliverStateexd, releaseStatus } from '@/meun/date'
export default {
  name: 'makeinvoiceCheck',
  mixins: [poMixins],
  props: {
    pagetitle: {
      type: String,
      default: '开票审批'
    }
  },
  computed: {
    // 开票信息
    orderInvoiceContentStateVo () {
      return this.checkFrom.orderInvoiceContentStateVo || {}
    },
    // 开票清单
    orderContractInvoiceStateVoList () {
      return this.checkFrom.orderInvoiceContentStateVo.orderContractInvoiceStateVoList || []
    }
  },
  mounted () {
    const { snaId } = this
    checkApi.getMakeinvoiceCheckInfo({
      snaId
    }).then(res => {
      if (isSuccess(res)) {
        this.checkFrom = res.data.obj
        this.$emit('update:data', deepClone(res.data.obj))
      } else {
        this.$message.error(res.data.msg)
      }
    })
  },
  data () {
    return {
      checkFrom: {
        orderInvoiceContentStateVo: {}
      },
      tableFieldex: [{
        name: 'contractCode',
        label: '合同编号'
      }, {
        name: 'customerContractCode',
        label: '客户合同编号'
      }, {
        name: 'signDate',
        label: '签订时间'
      }, {
        name: 'contractTotal',
        label: '合同金额'
      }, {
        name: 'accountsCollect',
        label: '应收账款'
      }, {
        name: 'accountsReceived',
        label: '已收账款'
      }, {
        name: 'invoiceMoney',
        label: '本次开票金额'
      }, {
        name: 'invoiceMoneyFilish',
        label: '已开票金额'
      }, {
        name: 'invoiceMoneyProcess',
        label: '开票审核中金额'
      }],
      tableField: [{
        name: 'contractCode',
        label: '合同编号'
      }, {
        name: 'customerContractCode',
        label: '客户合同编号'
      }, {
        name: 'brandName',
        label: '品牌'
      }, {
        name: 'proType',
        label: '型号'
      }, {
        name: 'orderNumber',
        label: '订货号'
      }, {
        name: 'number',
        label: '数量'
      }, {
        name: 'cbPrice',
        label: '销售单价'
      }, {
        name: 'cbUnitPrice',
        label: '供货单价'
      }, {
        name: 'cbRate',
        label: '毛利率'
      }, {
        name: 'taxRat',
        label: '税率'
      }, {
        name: 'taxAmount',
        label: '税额'
      }]
    }
  }
}
</script>

<style scoped>

</style>
